module.exports = __webpack_public_path__ + "img/rm_5.b39c5b62.png";